module.exports = __webpack_public_path__ + "assets/12d4e10208ac890dc963e9e21a5dc8db.png";